import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Divider, Drawer, IconButton, Button, colors } from '@material-ui/core';
import DashboardIcon from '@material-ui/icons/Dashboard';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import BusinessIcon from '@material-ui/icons/Business';
import LoopIcon from '@material-ui/icons/Loop';
import WcIcon from '@material-ui/icons/Wc';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import {
  AmlPages,
  Dashboards,
  FraudGlobalMap
} from '../../../../common/Constants';

import Footer from '../Footer.js';
import { SidebarNav } from './components';
const useStyles = makeStyles(theme => ({
  drawer: {
    width: 220,
    [theme.breakpoints.up('sm')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1)
  },
  divider: {
    marginBottom: theme.spacing(2)
  },
  nav: {
    marginBottom: theme.spacing(2)
  },
  drawerOpen: {
    width: 220,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1
    }
  },
  button: {
    color: colors.blueGrey[800],
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    whiteSpace: 'normal',
    width: '100%',
    fontWeight: theme.typography.fontWeightMedium
  },
  icon: {
    color: theme.palette.icon,
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1)
  }
}));

const Sidebar = props => {
  const classes = useStyles();
  const icons = [<BusinessIcon />, <WcIcon />, <FindInPageIcon />];
  const {
    open,
    variant,
    onClose,
    className,
    showFraudEngines,
    showAMLEngines,
    ...rest
  } = props;

  var Aml = AmlPages.map((key, idx) => ({
    title: key,
    href: `/solution/${key}`,
    icon: icons[idx] !== undefined ? icons[idx] : <FindInPageIcon />
  }));

  const [pageSet1] = React.useState(Aml);
  const [pageSet2] = React.useState(
    Array.from(FraudGlobalMap.keys()).map(key => ({
      title: key,
      href: `/solution/${key}`,
      icon: <BusinessIcon />
    }))
  );

  let pages =
    showFraudEngines === true && showAMLEngines === true
      ? pageSet1.concat(pageSet2)
      : showFraudEngines === true && showAMLEngines === false
      ? pageSet2
      : showFraudEngines === false && showAMLEngines === true
      ? pageSet1
      : pageSet1;

  const dashboardPages = [];
  if (showAMLEngines || (!showAMLEngines && !showFraudEngines)) {
    const amlDashStr = Dashboards[0];
    dashboardPages.push({
      title:
        amlDashStr.charAt(0).toUpperCase() +
        amlDashStr.substring(1).replace(/-/gi, ' '),
      href: `/solution/${amlDashStr}`,
      icon: <EqualizerIcon />
    });
  }
  if (showFraudEngines) {
    const fraudDashStr = Dashboards[1];
    dashboardPages.push({
      title:
        fraudDashStr.charAt(0).toUpperCase() +
        fraudDashStr.substring(1).replace(/-/gi, ' '),
      href: `/solution/${fraudDashStr}`,
      icon: <EqualizerIcon />
    });
  }
  pages = dashboardPages.concat(pages);
  if (showAMLEngines || (!showAMLEngines && !showFraudEngines)) {
    const amlDashStr = "Circular-Payment";
    pages.push({
      title:
        amlDashStr.charAt(0).toUpperCase() +
        amlDashStr.substring(1).replace(/-/gi, ' '),
      href: `/solution/${amlDashStr}`,
      icon: <LoopIcon />
    });
  }

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}>
      <div {...rest} className={clsx(classes.root, className)}>
        <Divider className={classes.divider} />
        <SidebarNav className={classes.nav} pages={pages} />
        <Divider style={{ marginTop: 200 }} className={classes.divider} />
        <Button
          className={classes.button}
          onClick={() => {
            window.open(process.env.REACT_APP_KEYMAKER_URI);
          }}>
          <div className={classes.icon}>
            <DashboardIcon />
          </div>
          Engine & Pipeline Configuration
        </Button>
      </div>
      <Footer />
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

export default Sidebar;
